document.querySelectorAll(".burger-menu").forEach((menu) => {
    menu.addEventListener("click", function () {
        document.querySelector(".mobile-nav").classList.toggle("active");
    });
});

document.addEventListener("DOMContentLoaded", function () {
    console.log('nav-load');
    function handleMobileBehavior() {
      const widgetNavMenus = document.querySelectorAll(".widget_nav_menu");
      const widgetTexts = document.querySelectorAll(".widget_text");
  
      if (window.innerWidth <= 575) {
        widgetNavMenus.forEach(menu => {
          menu.classList.remove("d-block");
        });
  
        widgetTexts.forEach(widget => {
          widget.removeEventListener("click", widget._clickHandler || (() => {}));
          
          widget._clickHandler = function (e) {
            if (e.target.tagName.toLowerCase() === "a") {
              return true;
            }
  
            const nextMenu = widget.nextElementSibling;
            if (!nextMenu || !nextMenu.classList.contains("widget_nav_menu")) return;
  
            widgetTexts.forEach(w => w.classList.remove("active"));
  
            if (nextMenu.style.display === "block") {
              widget.classList.remove("active");
              widgetNavMenus.forEach(menu => {
                slideUp(menu);
              });
            } else {
              widget.classList.add("active");
              widgetNavMenus.forEach(menu => {
                slideUp(menu);
              });
              slideDown(nextMenu);
            }
          };
  
          widget.addEventListener("click", widget._clickHandler);
        });
  
      } else {
        widgetNavMenus.forEach(menu => {
          menu.classList.add("d-block");
          menu.style.display = "";
        });
  
        widgetTexts.forEach(widget => {
          widget.removeEventListener("click", widget._clickHandler || (() => {}));
        });
      }
    }
  
    function slideUp(element, duration = 300) {
      element.style.transition = `height ${duration}ms, padding ${duration}ms, margin ${duration}ms`;
      element.style.boxSizing = 'border-box';
      element.style.height = element.offsetHeight + 'px';
      element.offsetHeight; // force reflow
      element.style.overflow = 'hidden';
      element.style.height = 0;
      element.style.paddingTop = 0;
      element.style.paddingBottom = 0;
      element.style.marginTop = 0;
      element.style.marginBottom = 0;
      setTimeout(() => {
        element.style.display = 'none';
        element.style.removeProperty('height');
        element.style.removeProperty('padding-top');
        element.style.removeProperty('padding-bottom');
        element.style.removeProperty('margin-top');
        element.style.removeProperty('margin-bottom');
        element.style.removeProperty('overflow');
        element.style.removeProperty('transition');
      }, duration);
    }
  
    function slideDown(element, duration = 300) {
      element.style.removeProperty('display');
      let display = window.getComputedStyle(element).display;
      if (display === 'none') display = 'block';
      element.style.display = display;
  
      let height = element.offsetHeight;
      element.style.overflow = 'hidden';
      element.style.height = 0;
      element.style.paddingTop = 0;
      element.style.paddingBottom = 0;
      element.style.marginTop = 0;
      element.style.marginBottom = 0;
      element.offsetHeight; // force reflow
      element.style.transition = `height ${duration}ms, padding ${duration}ms, margin ${duration}ms`;
      element.style.height = height + 'px';
      element.style.removeProperty('padding-top');
      element.style.removeProperty('padding-bottom');
      element.style.removeProperty('margin-top');
      element.style.removeProperty('margin-bottom');
  
      setTimeout(() => {
        element.style.removeProperty('height');
        element.style.removeProperty('overflow');
        element.style.removeProperty('transition');
      }, duration);
    }
  
    handleMobileBehavior();
  
    window.addEventListener("resize", handleMobileBehavior);
  });
  document.addEventListener("DOMContentLoaded", function () {
    function handleMobileBehavior() {
      const isMobile = window.innerWidth <= 575;
      const widgetTexts = document.querySelectorAll('.widget-column');
  
      widgetTexts.forEach((column) => {
        const textWidget = column.querySelector('.textwidget');
        const link = textWidget?.querySelector('a');
        const navMenu = column.querySelector('.widget_nav_menu');
  
        if (isMobile && link && navMenu) {
          // Clean old inline styles and classes
          navMenu.style.transition = 'max-height 0.4s ease';
          navMenu.style.overflow = 'hidden';
          navMenu.style.maxHeight = '0px';
  
          // Remove existing listener to prevent duplicates
          const clonedLink = link.cloneNode(true);
          link.parentNode.replaceChild(clonedLink, link);
  
          clonedLink.addEventListener('click', function (e) {
            // Ignore if it's a real link click
            if (e.target.tagName.toLowerCase() === 'a' && e.target.href) return;
  
            e.preventDefault();
  
            const isActive = column.classList.contains('active');
  
            // Close all widgets first
            widgetTexts.forEach((col) => {
              col.classList.remove('active');
              const menu = col.querySelector('.widget_nav_menu');
              if (menu) {
                menu.style.maxHeight = '0px';
              }
            });
  
            if (!isActive) {
              column.classList.add('active');
              navMenu.style.maxHeight = navMenu.scrollHeight + 'px';
            }
          });
        } else {
          // Reset behavior for desktop
          column.classList.remove('active');
          if (navMenu) {
            navMenu.style.maxHeight = null;
            navMenu.style.overflow = null;
            navMenu.style.transition = null;
          }
        }
      });
    }
  
    handleMobileBehavior();
  
    // Rerun logic on resize
    window.addEventListener("resize", handleMobileBehavior);
  });
  document.querySelectorAll('.nav-link.primary-link span').forEach(span => {
    span.addEventListener('click', function (event) {
      event.preventDefault(); // prevent default click behavior if needed
      this.closest('.nav-item').classList.toggle('active');
      // const submenu = this.closest('.nav-item').querySelector('.submenu-wrapper');
      // if (submenu) {
      //   submenu.classList.add('active');
      // }
    });
  });
  